<template>
	<div class="text-left">
		<h1 class="text-center">What's New With ASA24</h1>
		<!-- <v-card
			v-for="blogMessage in blogMessages"
			:key="blogMessage.messageId"
		>
			<v-card-title>{{blogMessage.messageTitle}}</v-card-title>
			<div v-html="blogMessage.messageBody"></div>
		</v-card> -->
		<br/>
		<blog-post
			v-for="blogMessage in blogMessages"
			:key="blogMessage.messageId"
			:date="blogMessage.dateRecorded"
			:title="blogMessage.messageTitle"
			:message="blogMessage.messageBody"
		></blog-post>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService'
import BlogPost from './BlogPost.vue';
export default {
	components: { BlogPost },
	name: 'WhatsNew',
	props: {
	},
	data: () => ({
		blogMessages: null
	}),
	mounted () {
		this.getBlogMessages();
	},
	methods: {
		getBlogMessages () {
			const me = this;
			researcherApiService.getBlogs()
				.then(function (response) {
					if (response && response.data) {
						me.blogMessages = response.data.data;
					}
				})
				.catch(function (e) {
					console.log(e);
				});
		}
	}
}
</script>

<style>

</style>
